module.exports = __webpack_public_path__ + "static/media/image.245c8002.svg";